import React, { lazy } from 'react';
const ExpertEndorsement = () => {
  return <section className="py-16 bg-orange-50" data-id="element-39">
      <div className="container mx-auto px-4" data-id="element-40">
        <div className="max-w-4xl mx-auto bg-white p-8 rounded-lg shadow-md" data-id="element-41">
          <div className="flex flex-col md:flex-row items-center" data-id="element-42">
            <div className="mb-6 md:mb-0 md:mr-8" data-id="element-43">
              <div className="img-container aspect-ratio-1-1 w-28 h-28 rounded-full overflow-hidden border-4 border-orange-200" data-id="element-44">
                <img src="https://images.unsplash.com/photo-1559839734-2b71ea197ec2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=200&q=80" alt="Dra. Martínez" className="img-content" width="112" height="112" loading="lazy" onError={e => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = 'https://via.placeholder.com/112x112/f5f5f5/a97142?text=Dra.M';
              }} data-id="element-45" />
              </div>
            </div>
            <div data-id="element-46">
              <p className="text-lg text-gray-700 italic mb-4" data-id="element-47">
                "Planificar tus cenas con batch cooking es la manera más
                efectiva de ahorrar dinero y tiempo sin sacrificar salud. Este
                método no solo te ayuda a comer mejor, sino que reduce
                significativamente el estrés de la semana."
              </p>
              <div data-id="element-48">
                <p className="font-bold text-gray-800" data-id="element-49">Dra. Ana Martínez</p>
                <p className="text-gray-600" data-id="element-50">
                  Nutricionista y Coach de Vida Saludable
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default ExpertEndorsement;